import 'css-chunksrc/client/scenes/projectLogs/styles.scss';export default {
  "projectLogs": "_projectLogs_6xetw_1",
  "loader": "_loader_6xetw_7",
  "content": "_content_6xetw_15",
  "body": "_body_6xetw_20",
  "logs": "_logs_6xetw_24"
};